__turbopack_context__.v({
  "backBtn": "vhtciW_backBtn",
  "gridList": "vhtciW_gridList",
  "linkCard": "vhtciW_linkCard",
  "result": "vhtciW_result",
});
